import md5 from "js-md5"
export default {
	config:{
		token:md5("X-CONSOLE-TOKEN"),
		token_at: md5("X-CONSOLE-TOKEN-AT"),
		route:md5("X-CONSOLE-ROUTE"),
		uploadImgToken:md5("X-CONSOLE-UPLOAD-IMG-TOKEN"),
		shop:md5("X-CONSOLE-CURRENT-SHOP")
		
	},
	setRoute(value){
		this.set(this.config.route,value)
	},
	getRoute(){
		const route = this.get(this.config.route);
		return route ? route : "/";
	},
	setToken(value){
		this.set(this.config.token,value)
	},
	getToken(){
		return{
			token:this.get(this.config.token),
			at:this.get(this.config.token_at),
		}
	},
	setCurrentShop(value){
		this.set(this.config.shop,JSON.stringify(value))
	},
	getCurrentShop(){
		const shop = this.get(this.config.shop);
		return JSON.parse(shop);
	},
	setUploadImgToken(value){
		this.set(this.config.uploadImgToken,value)
	},
	getUploadImgToken(){
		const uploadImgToken = this.get(this.config.uploadImgToken);
		return uploadImgToken ? uploadImgToken : "";
	},
	set(key,value){
		let base64 = require('js-base64').Base64;
		const v = window.localStorage.setItem(key,base64.encode(value));
		if (!v){
			return null;
		}
		return base64.decode(v);
	},
	get(key){
		let base64 = require('js-base64').Base64;
		const v = window.localStorage.getItem(key);
		if (!v){
			return null;
		}
		return base64.decode(v);
	},
	remove(key){
		window.localStorage.removeItem(key);
	},
	clear(){
		// Keep only non-sensitive reminder dismissals, scoped by employee/campus/expiry.
        Object.keys(window.localStorage).forEach(key => {
            if (!key.startsWith("campus-renewal:")) window.localStorage.removeItem(key);
        });
	}
}